import * as types from '../../lib/actionTypes.es6';
import { take, call, put } from 'redux-saga/effects';
import { getAmlConfigs, getAmlConfigRaw, publishAmlConfig, createAmlConfig } from '../../lib/requests.es6';
import * as actions from './actions.es6';
import { unAuthorizedNotification } from '../../lib/access.es6';
import { GAloggerException } from '../../lib/monitoring.es6';

export function* getAmlConfigsWatcher() {
  while (true) {
    const { payload: partner } = yield take(types.GET_AML_CONFIGS_REQUEST);
    try {
      const response = yield call(getAmlConfigs, partner);
      yield put(actions.getAmlConfigsSuccess(response.data.data));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getAmlConfigsFail(e.response ? e.response.data : {}));
    }
  }
}

export function* getAmlConfigRawWatcher() {
  while (true) {
    const { payload: { partner, type } } = yield take(types.GET_AML_CONFIG_RAW_REQUEST);
    try {
      const response = yield call(getAmlConfigRaw, partner, type);
      yield put(actions.getAmlConfigRawSuccess(response.data.data.yaml));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getAmlConfigRawFail(e.response ? e.response.data : {}));
    }
  }
}

export function* publishAmlConfigWatcher() {
  while (true) {
    const { payload: { partner, type, rawYaml } } = yield take(types.PUBLISH_AML_CONFIG_REQUEST);
    try {
      const response = yield call(publishAmlConfig, partner, type, rawYaml);
      yield put(actions.publishAmlConfigSuccess(response.data));
      yield put(actions.getAmlConfigsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.publishAmlConfigFail(e.response ? e.response.data : {}));
    }
  }
}

export function* createAmlConfigWatcher() {
  while (true) {
    const { payload: { partner, rawYaml } } = yield take(types.CREATE_AML_CONFIG_REQUEST);
    try {
      const response = yield call(createAmlConfig, partner, rawYaml);
      yield put(actions.createAmlConfigSuccess(response.data));
      yield put(actions.getAmlConfigsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.createAmlConfigFail(e.response ? e.response.data : {}));
    }
  }
}
